import { t } from 'i18next';
import { palette } from '../../material-ui/palette';

export enum VisitorBookingLabelState {
    STARTED = 'Started',
    NOT_STARTED = 'Not Started',
    FINISHED = 'Finished',
}

export const setVisitorBookingChipColor = (label: string) => {
    switch (label) {
        case VisitorBookingLabelState.STARTED:
            return palette.bookingChip.started;
        case VisitorBookingLabelState.NOT_STARTED:
            return palette.bookingChip.not_started;
        case VisitorBookingLabelState.FINISHED:
            return palette.bookingChip.finished;
        default:
            return palette.bookingChip.not_started;
    }
};

export const setVisitorLabelText = (label: string) => {
    switch (label) {
        case VisitorBookingLabelState.STARTED:
            return t('common.started') as string;
        case VisitorBookingLabelState.NOT_STARTED:
            return t('common.not_started') as string;
        case VisitorBookingLabelState.FINISHED:
            return t('common.finished') as string;
        default:
            return t('common.not_started') as string;
    }
};
